
import classes from './TestResult.module.css'

type Props = {
    totalResult: number, currentResult: number
}

const TestResult = ({totalResult, currentResult}: Props) => {

  
    return(
        <div className={classes.result}>
            <h2 className={classes.result__title}>Ваш результат</h2>
 
            <div className={classes.result__data}>
                {currentResult} /  {totalResult}
            </div>

            <br/>
            <div className={classes.result__data}>
                {(currentResult * 100 / totalResult).toFixed(1)} /  100%
            </div>
        </div>
    )
}

export default TestResult